// @flow
import { resolve, reject } from 'redux-optimist-promise';
import { get } from 'lodash';

import createReducer from 'Store/utils/createReducer';

import PRICE_TICKET_REQUEST from './constants';

const initialState = {
  isLoading: true,
  price: {},
};

export default createReducer(initialState, {
  [PRICE_TICKET_REQUEST](state: ReduxState) {
    return {
      ...state,
      isLoading: true,
    };
  },
  [resolve(PRICE_TICKET_REQUEST)](
    state: ReduxState,
    action: PriceTicketRequestResolvedAction,
  ): ReduxState {
    const price = get(action, 'payload.price') || {};

    return {
      isLoading: false,
      price,
    };
  },
  [reject(PRICE_TICKET_REQUEST)](state: ReduxState): ReduxState {
    return {
      ...state,
      isLoading: false,
    };
  },
});
